export const controllers: AbortController[] = [];

export const addController = (controller: AbortController) => {
  controllers.push(controller);
};

export const cancelAllRequests = () => {
  controllers.forEach((controller) => controller.abort());
  controllers.length = 0; // clear after aborting
};
